import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';

type AnswerType = 'true' | 'false' | 'missed';
type AnswerStatusType = 'correct' | 'incorrect' | 'missed';

export function useTrueOrFalseCorrection(
  props: QuestionViewPropsFor<QuestionTypeEnum.TRUE_OR_FALSE>,
) {
  const { question, value } = props;

  const hasAnswer = value !== null && value !== undefined;
  const answer: AnswerType = !hasAnswer ? 'missed' : value ? 'true' : 'false';
  const answerStatus: AnswerStatusType = !hasAnswer
    ? 'missed'
    : value === question.isTrue
    ? 'correct'
    : 'incorrect';

  return { answer, hasAnswer, answerStatus };
}
